import axios from 'axios';
import qs from 'qs';
import BlumarConfig from '../blumar-config';

let serviceErrorHandler = null;

export function setServiceErrorHandler(handler) {
  serviceErrorHandler = typeof handler === 'function' ? handler : null;
}

export function blumarApiAxios(options) {
  let baseURL = BlumarConfig.baseApiUrl;
  return createAxios(baseURL, options);
}

export function blumarWebserviceAxios(options) {
  let baseURL = BlumarConfig.baseWebserviceUrl;
  return createAxios(baseURL, options);
}

export function createAxios(baseURL, {headers = {}, ...options} = {}) {
  const client = axios.create({
    baseURL,
    paramsSerializer: (params) => qs.stringify(params),
    headers: {
      // access_key: "2cf321cb-606d-4a42-ae0c-1878b9d85424",
     'Access-Key': "3618316a-1453-11ee-be56-0242ac120002",
      ...headers,
    },
    ...options,
  });

  client.interceptors.response.use(
    response => response,
    error => {
      const response = error.response;
      const status = response ? response.status : null;

      const isServerError = status >= 500 && status < 600;
      if ((!response || isServerError) && serviceErrorHandler) serviceErrorHandler(error);

      return Promise.reject(error);
    },
  );

  return client;
}



// WEBPACK FOOTER //
// ./src/services/HttpHelper.js